import { handleActions } from 'redux-actions'
import * as rawActions from '../actions'

const defaultState = null

export default handleActions(
  {
    [rawActions.openExportGalleryOptionsDialog](state, action) {
      return action.payload
    },
    [rawActions.closeExportGalleryOptionsDialog](state, action) {
      return null
    },
    [rawActions.resetGalleryState](state, action) {
      return defaultState
    },
  },
  defaultState
)
